import { Component, ChangeDetectionStrategy, inject } from "@angular/core";
import { SafeUrl } from "@angular/platform-browser";
import { ThemeManagerService } from "@vp/theme-manager";
import { ANON_CONFIG } from "@vp/shared/tokens";

@Component({
  selector: "vp-top-nav-logo",
  standalone: false,
  templateUrl: "./top-nav-logo.component.html",
  styleUrls: ["./top-nav-logo.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopNavLogoComponent {
  private readonly themeManagerService = inject(ThemeManagerService);
  private readonly anonConfig = inject(ANON_CONFIG, { optional: true });

  logo: SafeUrl = this.themeManagerService.logo;

  // Anonymous clinical-informatics requesters have no authenticated home, so the
  // logo returns them to their triage board rather than the theme default.
  logoRedirectLink =
    this.anonConfig?.origin === "VCLINICALINFORMATICIST"
      ? "/clinical-informatics-support"
      : this.themeManagerService.logoRedirectLink;
}
